import { render, staticRenderFns } from "./PublicContact.vue?vue&type=template&id=e919cf72&"
import script from "./PublicContact.vue?vue&type=script&lang=ts&"
export * from "./PublicContact.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports